import { MODEL_ERROR_CODES } from "../MPNsToReceive/constants";
import { SERIAL_ERROR_CODES } from "../ScanSerials/constants";

export const HANDLED_EXCEPTION_CODES: string[] = [
  'InvalidParameterException',
  'ConcurrentWriteException',
  'DependencyException',
];

export const UNFIED_RECEIVE_CTI_URL = 'https://t.corp.amazon.com/create/templates/19c6ca30-aee7-4daa-8de9-238212f71516';
export const CUT_A_TICKET_MESSAGE = `Please create a ticket <a href=${UNFIED_RECEIVE_CTI_URL}>here</a> for assistance.`;

export const EXCEPTION_ERROR_CODES: any = {
  InvalidParameterException: 'The exception could not be created due to incorrect parameters. ',
  ConcurrentWriteException: 'The exception could not be created at this time. Please try recreating the exception. If the issue persists, ' + CUT_A_TICKET_MESSAGE,
  DependencyException: 'The exception could not be created at this time. Please try again later. If the issue persists, ' + CUT_A_TICKET_MESSAGE,
};

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong while creating the exception. ' + CUT_A_TICKET_MESSAGE;

export const SERIAL_ERRORS = [
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_NOT_REQUIRED,
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_REQUIRED,
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT,
  SERIAL_ERROR_CODES.serial_id_not_exists_asn,
  SERIAL_ERROR_CODES.MPN_NOT_EXPECTED_IN_RECEIVE_REFERENCE,
  SERIAL_ERROR_CODES.COMPOSITE_DUPLICATE_SERIAL_INVALID_STATE,
  SERIAL_ERROR_CODES.COMPOSITE_DUPLICATE_SERIAL,
  SERIAL_ERROR_CODES.SERIAL_ALREADY_EXISTS,
  SERIAL_ERROR_CODES.TOWNSEND_IDENTIFIER_COMBINATION_INVALID,
  SERIAL_ERROR_CODES.SERIAL_ALREADY_RECEIVED_FOR_SHIPMENT,
];

export const EXCEPTION_IGNORED_ERROR_CODES = [
  SERIAL_ERROR_CODES.COMPOSITE_DUPLICATE_SERIAL_INVALID_STATE,
  SERIAL_ERROR_CODES.SERIAL_ALREADY_EXISTS,
  SERIAL_ERROR_CODES.SERIAL_EXPECTED_IN_SHIPMENT,
  MODEL_ERROR_CODES.model_is_not_expected,
];


export const DEFAULT_EXCEPTION_STATE = {
  SHIPMENT_ID: '',
  TITLE: '',
  SITE: '',
  TRACKING_NUMBER: '',
  ORDER_NUMBER: '',
  APN_IPN_NUMBER: '',
  SERIAL_NUMBERS: [],
  ORDER_LINE_ITEM_NUMBER: '',
  ORDER_TYPE: {
    label: '',
    value: '',
  },
  MODEL: '',
};

export const JANUS_RESOLVER_GROUP = {
  value: 'JANUS',
  label: 'JANUS',
};
